import type { ReactNode } from 'react';
import { SUPPORTED_CURRENCIES, formatMoney, type BandPosition, type CurrencyCode } from '@nest-recruit/shared';
import { Chip } from '../../components/Chip';
import { EMPTY } from '../../lib/format';

/** A minor-unit amount as it reads: `৳43,000` (06-qol §11 — always with its symbol). `—` when masked or empty. */
export function money(minor: string | null | undefined, currency: string | null | undefined): string {
  if (minor === null || minor === undefined || !currency) return EMPTY;
  return formatMoney({ amountMinor: BigInt(minor), currency: isCurrency(currency) ? currency : 'BDT' });
}

function isCurrency(value: string): value is CurrencyCode {
  return (SUPPORTED_CURRENCIES as readonly string[]).includes(value);
}

/** "Inside the band ৳45,000–৳65,000" — and, outside it, that one more approval follows (S12 Q3). */
export function BandNote({
  position,
  minMinor,
  maxMinor,
  currency,
  isEnforced,
}: {
  readonly position: BandPosition | null;
  readonly minMinor: string | null;
  readonly maxMinor: string | null;
  readonly currency: string;
  readonly isEnforced: boolean;
}): ReactNode {
  if (position === null) return null;
  if (position === 'no_band') return <Chip tone="neutral">No pay band on this job</Chip>;
  const band = `${money(minMinor, currency)}–${money(maxMinor, currency)}`;
  if (position === 'inside') return <Chip tone="success">Inside the band {band}</Chip>;
  const side = position === 'above' ? 'Above' : 'Below';
  return <Chip tone="warning">{isEnforced ? `${side} the band ${band} — one more approval` : `${side} the band ${band}`}</Chip>;
}
